import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (path) =>
  `${API}/files/${path}?auth=${encodeURIComponent(localStorage.getItem("mt_token") || "")}`;

export const mediaUrl = (path) => (path ? `${API}/public/media/${path}` : "");

export const money = (n) => `฿ ${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};
